import type { DriverType } from '@ria-client/supergraph/marketplace/types';
import type { SummaryTableRowType } from '@ria-client/supergraph/roundup/types';
import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';
import { CdApysDriver } from './cd-apys-driver';

export interface DriverProps {
  borderBottom?: boolean;
  driver: DriverType;
  oneYearApyEntity?: SummaryTableRowType['oneYearApyEntity'];
  threeYearApyEntity?: SummaryTableRowType['threeYearApyEntity'];
  fiveYearApyEntity?: SummaryTableRowType['fiveYearApyEntity'];
  renderCdApys?: boolean;
}

export function Driver({
  borderBottom = false,
  driver,
  oneYearApyEntity,
  threeYearApyEntity,
  fiveYearApyEntity,
  renderCdApys = false,
}: DriverProps) {
  const hasMultiAPYDrivers =
    !!oneYearApyEntity?.driverApy?.value ||
    !!threeYearApyEntity?.driverApy?.value ||
    !!fiveYearApyEntity?.driverApy?.value;

  return (
    <div className={`flex py-2 ${borderBottom ? 'border-b border-border' : ''}`}>
      <div className="basis-1/4 shrink-0">
        <p className="typography-text-small text-muted-foreground">{driver.label}</p>
      </div>
      <div className="ml-3 w-full">
        {renderCdApys && hasMultiAPYDrivers ? (
          <CdApysDriver
            dividerSpacing={2}
            driver={driver}
            fiveYearApyEntity={fiveYearApyEntity}
            oneYearApyEntity={oneYearApyEntity}
            threeYearApyEntity={threeYearApyEntity}
          />
        ) : (
          <div className="flex flex-row">
            <p className="mr-1">{driver.value || 'N/A'}</p>
            {driver.valueTooltip && (
              <DisclosureTooltip
                trigger={
                  <button aria-label={`${driver.label} info`} className="p-0" type="button">
                    <CircleHelp aria-hidden size={24} />
                  </button>
                }
              >
                <span className="typography-text-small">{driver.valueTooltip}</span>
              </DisclosureTooltip>
            )}
          </div>
        )}
        {driver.description && (
          <p className="typography-text-small leading-normal text-muted-foreground">
            {driver.description}
          </p>
        )}
      </div>
    </div>
  );
}
